/* =====================================================
   assets/pdp-key-ingredients-2026.js
   NuFACE 2026 — PDP Key Ingredients mobile carousel
   KC 2026-06-24 · continuous loop KC 2026-06-25

   ≤700px only (CSS scroll-snap flex track). CONTINUOUS gallery:
   the originals are cloned into a full set BEFORE and AFTER, so a
   preview tile always peeks on the right (and left) and the loop is
   seamless — once scrolling settles past a set boundary we jump back
   by one set width into the originals (the clones are identical, so
   it's invisible). Manual only (arrows + native swipe; no autoplay).
   Clones are display:none above 700px (CSS) so the desktop grid shows
   only the originals. Images are eager (liquid) incl. clones, so the
   preview never flashes blank.
   ===================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.kiInited === '1') return;

    var track = section.querySelector('[data-ki-track]');
    var prev = section.querySelector('[data-ki-prev]');
    var next = section.querySelector('[data-ki-next]');
    if (!track) return;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll('.pdp-key-ingredients-2026__card')
    );
    var n = originals.length;
    if (n < 2) return; // nothing to loop

    section.dataset.kiInited = '1';

    // Clone a full set before and after for a seamless loop.
    var beforeFrag = document.createDocumentFragment();
    var afterFrag = document.createDocumentFragment();
    originals.forEach(function (card) {
      var after = card.cloneNode(true);
      after.classList.add('is-clone');
      after.setAttribute('aria-hidden', 'true');
      afterFrag.appendChild(after);
      var before = card.cloneNode(true);
      before.classList.add('is-clone');
      before.setAttribute('aria-hidden', 'true');
      beforeFrag.appendChild(before);
    });
    track.appendChild(afterFrag);
    track.insertBefore(beforeFrag, track.firstChild);

    var mql = window.matchMedia('(max-width: 700px)');

    function allCards() {
      return track.querySelectorAll('.pdp-key-ingredients-2026__card');
    }
    function step() {
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return originals[0].getBoundingClientRect().width + gap;
    }
    function snapOffset() {
      return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
    }
    function setWidth() {
      return n * step();
    }

    function centerOriginals() {
      if (!mql.matches) return;
      track.scrollLeft = setWidth() - snapOffset(); // first ORIGINAL, centered (instant)
    }

    // Keep the scroll within the originals' set; jump by ±setWidth once it crosses into a
    // clone set. Seamless because the clones are identical to the originals.
    function normalize() {
      if (!mql.matches) return;
      var s = setWidth();
      var pad = snapOffset();
      if (track.scrollLeft >= 2 * s - pad - 1) track.scrollLeft -= s;
      else if (track.scrollLeft < s - pad - 1) track.scrollLeft += s;
    }

    function setActive() {
      var list = allCards();
      if (!list.length) return;
      var idx = Math.round((track.scrollLeft + snapOffset()) / step());
      idx = Math.max(0, Math.min(idx, list.length - 1));
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle('is-active', i === idx);
      }
    }

    function advance(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { advance(-1); });
    if (next) next.addEventListener('click', function () { advance(1); });

    var raf, settle;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActive);
      clearTimeout(settle);
      settle = setTimeout(normalize, 90); // jump back to the originals once scrolling settles
    }, { passive: true });

    function onMQ() { if (mql.matches) { centerOriginals(); setActive(); } }
    if (mql.addEventListener) mql.addEventListener('change', onMQ);
    else if (mql.addListener) mql.addListener(onMQ);

    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActive);
    });

    requestAnimationFrame(function () { centerOriginals(); setActive(); });
    window.addEventListener('load', function () { centerOriginals(); setActive(); });
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.pdp-key-ingredients-2026');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
